import parseISO from 'date-fns/parseISO'

export const parseIsoDate = (date: string): Date => parseISO(date)

export const parseIsoDateTime = (date: string): Date => new Date(date)
